import React from 'react'
import cn from '../../helpers/classnames'

export const BaseSection = (props) => (
  <section
    {...props}
    className={cn('max-w-screen-xl mx-auto px-4', props.className)}
  />
)
